export default "__VITE_ASSET__C1mQiac5__"